<template>
  <div>
    <h6 class="mt-3 font-weight-bold">Heavy Equipment Rental</h6>
    <b-table
      class="mt-2"
      bordered
      table-class="table-heavy-equipment-rental"
      thead-class="bg-color text-center"
      empty-text="No data"
      :items="detail.equipment"
      :fields="fields"
      responsive
      show-empty
    >
      <template #thead-top>
        <b-tr>
          <b-th></b-th>
          <b-th></b-th>
          <b-th></b-th>
          <b-th></b-th>
          <b-th></b-th>
          <b-th></b-th>
          <b-th></b-th>
          <b-th></b-th>
          <b-th colspan="5">Budget Number</b-th>
        </b-tr>
      </template>
      <template v-slot:cell(no)="items">
        {{ items.index + 1 }}
      </template>
      <template v-slot:cell(description)="items">
        {{ !detail.approval_status.isEdit ? items.item.description : '' }}
        <b-form-group
          v-if="detail.approval_status.isEdit"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <b-form-input
            autocapitalize="off"
            v-model="items.item.description"
          />
        </b-form-group>
      </template>
      <template v-slot:cell(detail)="items">
        <div
          v-for="(n, i) in items.item.rowBUP.length"
          :key="i"
          class="border-bottom p-3"
        >
          {{ items.item.rowBUP[i].detail }}
        </div>
        <div class="sub-total">sub total</div>
      </template>
      <template v-slot:cell(working_hour)="items">
        <div
          v-for="(n, i) in items.item.rowBUP.length"
          :key="i"
          class="border-bottom p-3"
        >
          {{ formatPrice(items.item.rowBUP[i].working_hour) }}
        </div>
        <div class="sub-total">
          {{ formatPrice(subTotal(items, 'working_hour')) }}
        </div>
      </template>
      <template v-slot:cell(base_rate_hours)="items">
        <div
          v-for="(n, i) in items.item.rowBUP.length"
          :key="i"
          class="border-bottom p-3"
        >
          {{ formatPrice(items.item.rowBUP[i].base_rate_hours) }}
        </div>
        <div class="sub-total">.</div>
      </template>
      <template v-slot:cell(fuel_const)="items">
        <div
          v-for="(n, i) in items.item.rowBUP.length"
          :key="i"
          class="border-bottom p-3"
        >
          {{ formatPrice(items.item.rowBUP[i].fuel_const) }}
        </div>
        <div class="sub-total">.</div>
      </template>
      <template v-slot:cell(unit_price)="items">
        <div
          v-for="(n, i) in items.item.rowBUP.length"
          :key="i"
          class="border-bottom p-3"
        >
          {{ formatPrice(items.item.rowBUP[i].unit_price) }}
        </div>
        <div class="sub-total">.</div>
      </template>
      <template v-slot:cell(payment_amount)="items">
        <div
          v-for="(n, i) in items.item.rowBUP.length"
          :key="i"
          class="border-bottom p-3"
        >
          {{ formatPrice(items.item.rowBUP[i].payment_amount) }}
        </div>
        <div class="sub-total">
          {{ formatPrice(subTotal(items, 'payment_amount')) }}
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      types: Object,
      default: () => ({})
    }
  },

  data: () => ({
    fields: [
      { key: 'no', label: 'No', tdClass: 'text-center align-middle' },
      { key: 'description', tdClass: 'text-center align-middle', thStyle: 'width: 250px' },
      { key: 'detail', label: 'Equipment Type', tdClass: 'text-center p-0', thStyle: 'width: 200px' },
      { key: 'working_hour', label: 'Hour', tdClass: 'text-center p-0', thStyle: 'width: 50px' },
      { key: 'base_rate_hours', label: 'Base Rate (IDR/Hour)', tdClass: 'text-center p-0', thStyle: 'width: 50px' },
      { key: 'fuel_const', label: 'Fuel Cons (Lts/Hour)', tdClass: 'text-center p-0', thStyle: 'width: 50px' },
      { key: 'unit_price', label: 'Unit Price (IDR/Hour)', tdClass: 'text-center p-0' },
      { key: 'payment_amount', label: 'Payment Ammount (IDR)', tdClass: 'text-center p-0' },
      { key: 'cc', label: 'CC', tdClass: 'text-center align-middle' },
      { key: 'plan', label: 'Plan', tdClass: 'text-center align-middle' },
      { key: 'ac', label: 'A/C', tdClass: 'text-center align-middle' },
      { key: 'sub_ac', label: 'Sub A/C', tdClass: 'text-center align-middle' },
      { key: 'pa', label: 'P/A', tdClass: 'text-center align-middle' }
    ]
  }),

  methods: {
    subTotal(items, key) {
      let x = 0
      items.item.rowBUP.forEach(d => {
        x += parseFloat(d[key])
      })

      return x
    },
    formatPrice(value, decLen = 2) {
      return value !== undefined ? Number(value.toFixed(decLen)).toLocaleString(undefined, { minimumFractionDigits: decLen, maximumFractionDigits: decLen }) : ''
    }
  }
}
</script>

<style>

</style>
